module.exports = __webpack_public_path__ + "img/trustpilot_stars.64883a01.svg";